export class HandledError extends Error {}
